module.exports = __webpack_public_path__ + "static/media/circle.2fa7cb85.png";